import { ConnectionCalendar, ExternalConnection, ID } from '@griply/types';

import { canConnectionWriteEvents } from './can-connection-write-events';
import { getConnectionCalendar } from './get-connection-calendar';

// Structural rather than ExternalCalendarEvent, so a CalendarEventRef (which carries the same
// pair, non-optional) resolves through the same gate as a grid event.
export type ExternalEventEditableTarget = {
  connectionId?: ID;
  calendarId?: ID;
};

export type GetExternalEventEditableOptions = {
  connections: ExternalConnection[];
  // required so no write surface can silently skip the per-calendar half of the gate
  calendars: ConnectionCalendar[];
  // absent on a backend deployed before RSVP support, where every event reads as your own —
  // only an explicit `false` means you were invited rather than organising
  isOrganizer?: boolean;
};

export const getExternalEventEditable = (
  { connectionId, calendarId }: ExternalEventEditableTarget,
  { connections, calendars, isOrganizer }: GetExternalEventEditableOptions,
): boolean => {
  if (!connectionId || !calendarId) {
    return false;
  }
  if (isOrganizer === false) {
    return false;
  }

  // absent (pre-flag backend) and unresolved (still loading) must not read as read-only
  const calendar = getConnectionCalendar(calendars, {
    connectionId,
    calendarId,
  });
  if (calendar?.canWrite === false) {
    return false;
  }

  const connection = connections.find(({ id }) => id === connectionId);

  return !!connection && canConnectionWriteEvents(connection);
};
